import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import styles from '../styles/settingsStyles';

export interface SettingsSectionProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    actionsView?: React.ReactNode;
}

export const AppSettingsSection: React.FC<SettingsSectionProps> = ({ title, description, children, actionsView }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <h4 style={styles.appSettingsSectionTitleStyle}>{title}</h4>
                {actionsView}
            </div>
            {description && <Text type="secondary">{description}</Text>}
            {children}
        </div>
    );
};
